import { LitElement, html } from '~/lib/bn-lit-element';
import { openBinOrdersButtonParcel } from '~/parcels/index.js';
import './parcel-loader';

class OrderEditorButton extends LitElement {
  static get properties() {
    return {
      binHref: { type: String },
      style: { type: Object },
    };
  }

  render() {
    const passThroughProperties = {
      binHref: this.binHref,
      title: 'Create and View Orders',
      style: this.style,
    };

    return html`
      <parcel-loader
        .parcel=${openBinOrdersButtonParcel}
        .passThroughProperties=${passThroughProperties}
      ></parcel-loader>
    `;
  }
}

window.customElements.define('order-editor-button', OrderEditorButton);
